import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-buttons',
    templateUrl: './buttons.component.html',
    styleUrls: ['./buttons.component.scss'],
    standalone: false
})
export class ButtonsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
